const ACTIVITY_TYPES = ["train"];

const PAUSE_TYPES = ["prep", "countdown", "rest", "break", "start"];

const TIMER_ORIGIN = ["HomePlayer", "Activity", "Pause"];

export { ACTIVITY_TYPES, PAUSE_TYPES, TIMER_ORIGIN };
